/* global Element */

import PropTypes from 'prop-types'
import React from 'react'
import clsx from 'clsx'

import AudioMedia from './AudioMedia'
import VideoMedia from './VideoMedia'

const mediaComponents = {
  audio: AudioMedia,
  video: VideoMedia,
}

export default function Media(props) {
  const {
    className,
    classes = {},
    disabled = false,
    media,
    mediaFormat,
    ...otherProps
  } = props

  const MediaComponent = mediaComponents[mediaFormat]

  if (!MediaComponent) {
    return null
  }

  /* eslint-disable react/jsx-props-no-spreading */
  return (
    <MediaComponent
      className={clsx(className, classes[mediaFormat])}
      disabled={disabled}
      media={media}
      {...otherProps}
    />
  )
  /* eslint-enable react/jsx-props-no-spreading */
}

Media.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string),
  disabled: PropTypes.bool,
  media: PropTypes.string,
  mediaElementRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  mediaFormat: PropTypes.oneOf(['audio', 'video']),
}
